import _ from "lodash";

/* eslint-disable angular/document-service */
export const loadTheme = (theme, tenant, onloadCallback) => {
	const url = `${theme}.bundle.js`;
	const script = document.createElement("script");
	const scripts = document.getElementsByTagName("script");
	const lastScript = scripts[scripts.length - 1];
	script.async = false;
	script.src = url;
	script.onload = onloadCallback;

	// Insert custom script into head
	lastScript.parentNode.insertBefore(script, lastScript.nextSibling);

	// Add custom class name to body
	document.getElementsByTagName("body")[0].classList.add(theme);
	document.getElementsByTagName("body")[0].classList.add(_.kebabCase(tenant));
};

/* eslint-disable angular/document-service */
export const loadTranslations = (config, $translatePartialLoaderProvider) => {
	const theme = config.theme;
	const translateKey = config.translateKey;

	// add custom translation

	const customI18NUrl = `custom/${theme}`;
	$translatePartialLoaderProvider.addPart(customI18NUrl);

	// add tenant specific translations if present
	if (translateKey) {
		const tenantSpecificI18NUrl = `custom/${theme}/tenants/${translateKey}`;
		$translatePartialLoaderProvider.addPart(tenantSpecificI18NUrl);
	}
};

export const loadPlausible = ($document, $window, configService, envService) => {
	const url = `${configService.getPlausibleHost()}js/script.pageview-props.js`;

	// Script-Tag dynamisch einfügen
	const el = $document[0].getElementsByTagName("script")[0];
	const script = $document[0].createElement("script");
	script.type = "text/javascript";
	script.async = true;
	script.defer = true;
	script.dataset.domain = [
		location.hostname.replace(/^[^\.]*\./, ""),
		location.hostname,
	].join(",");
	script.setAttribute("event-tenant", envService.getTenant());
	script.src = url;

	el.parentNode.insertBefore(script, el);

	// Plausible Funktions-Stub bereitstellen (für Custom Events)
	$window.plausible =
		$window.plausible ||
		function () {
			($window.plausible.q = $window.plausible.q || []).push(arguments);
		};
};



// WEBPACK FOOTER //
// ./src/app/bootstrap/loadCustoms.js